<div class="row justify-content-between">
  <div class="col" style="z-index: 250">
    <div class="row" style="flex-wrap:nowrap">
      <div class="col-auto">
        <div class="welcomeText">
          Benvenuto @if (user) {
          <span>{{user.firstName}} {{user.lastName}}</span>
        }
        (<a (click)="logout()">Logout</a>)
      </div>
    </div>
    <div class="col-auto" style="display:flex;align-items:center;">
      <div class="sep vertical"></div>
    </div>
    <div class="col d-flex align-items-center">
      @if (selectedSociety) {
        <div class="welcomeText header-section" style="padding-right:1.5rem">
          <span (click)="openModal()" class="welcomeText header-section pointer pr-1">
            <img src="assets/images/icons/cambio-gruppo.svg" ngbTooltip="Cambia società" fill = "white" class="group-change-icon menu-icon header-icon">
          </span>
          <span>{{selectedSociety.name}}</span>
        </div>
      }
    </div>
  </div>
</div>

<div class="col">
  <div class="row" style="flex-wrap:nowrap">
    <app-uploader-queue></app-uploader-queue>
    <div>
      <app-downloader-queue></app-downloader-queue>
      <pwc-downloader-queue></pwc-downloader-queue>
    </div>
  </div>
</div>

<div class="col">
  <div class="rightHeader d-flex flex-row-reverse">
    <div class="d-inline-block pointer" ngbDropdown #myDrop="ngbDropdown" display="dynamic" placement="bottom-right">
      <div class="baloon" ngbDropdownToggle id="dropdownManual">
        {{userInitials|uppercase}}
      </div>
      <div ngbDropdownMenu aria-labelledby="dropdownManual">
        <button ngbDropdownItem (click)="navigateToChangePassword()">Cambio password</button>
        <ng-container *canAccess="AuthorityCodeEnum.ROLE_ECOBONUS_ACCESS">
          @if (environment.configuration.dynamicFaq?.active) {
            <button ngbDropdownItem (click)="navigateToFaq()">FAQ e
            Richieste di Assistenza</button>
          }
        </ng-container>
        @if (environment.configuration.dynamicFaq?.active) {
          <button ngbDropdownItem
          (click)="navigateToMySupportRequests()">Le mie Richieste di Assistenza</button>
        }
        @if (environment.configuration.showPrivacy) {
          <button ngbDropdownItem
            (click)="navigateToPrivacyPolicy()">Privacy
          policy</button>
        }
        @if (environment.configuration.showPrivacy) {
          <button ngbDropdownItem
            (click)="navigateToTermsAndConditions()">Terms and
          conditions</button>
        }
        @if (!environment.configuration.showPrivacy && environment.configuration.termsAndConditionFileName != '') {
          <a ngbDropdownItem
            (click)="download('termsAndCondition', 'Terms&Conditions.pdf')">
            <span>Terms and conditions</span>
          </a>
        }
        <button ngbDropdownItem (click)="logout()">Logout</button>
      </div>
    </div>

    <div class="notification-bell mx-3" routerLink="/notifications"
      [ngbTooltip]="notificationCount > 0 ? 'Ci sono nuove notifiche' : 'Non ci sono nuove notifiche'"
      style="position:relative;">
      @if (notificationCount>0) {
        <span class="badge badge-danger pointer" style="position:absolute;top:-50%;right:0;"
        >{{ notificationCount }}</span>
      }
      <img src="/assets/images/icons/bell.svg" class="notification-image">
    </div>

    @if (manualFileName) {
      <div class="mx-3">
        <a (click)="download('manual', 'Manuale utente - Piattaforma ECOBONUS.pdf')">
          <img src="/assets/images/icons/manual_b2b.svg" ngbTooltip="{{'header.user-manual' | translate }}"
            class="small-icon pointer">
        </a>
      </div>
    }

    @if (faqFileName && !environment.configuration.dynamicFaq?.active) {
      <div class="mx-3">
        <a (click)="download('faq', 'FAQ_Piattaforma Ecobobonus.pdf')">
          <img src="/assets/images/icons/help.svg" ngbTooltip="FAQ" class="small-icon pointer">
        </a>
      </div>
    }

    @if (secondaryLogo) {
      <div class="d-inline-block">
        <img [src]="secondaryLogo" alt="" class="logo-secondary">
      </div>
    }

  </div>
</div>
</div>

<app-society-selection #societySelection
  bindLabel="name" [currentSociety]="selectedSociety" (changeSociety)="setCurrentSociety($event)">
</app-society-selection>

